module.exports = __webpack_public_path__ + "4292af4829e94948a190ef101837cdae.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/favicon.png
// module id = ./app/images/favicon.png
// module chunks = 3